import type { Tracker, UserData } from './tracker'

export class InternalTracker implements Tracker {
  trackerId = 'internal'
  userId: string | undefined
  locationId: string | undefined
  organizationId: string | undefined
  accessToken: string | undefined
  baseUrl: string
  features: Set<string> | undefined
  loadingFeatures: Promise<void> | undefined

  constructor(serverUrl: string) {
    this.baseUrl = serverUrl
  }

  identify(userData: UserData) {
    const { location_id, organization_id, userId } = userData
    if (
      location_id === this.locationId &&
      organization_id === this.organizationId &&
      userId === this.userId
    )
      return
    this.locationId = location_id
    this.organizationId = organization_id
    this.userId = userId
    this.accessToken = userData.accessToken
    this.features = undefined
  }

  private getHeaders(): Record<string, string> {
    return {
      Authorization: `Bearer ${this.accessToken}`,
      'Location-ID': this.locationId!,
      'Organization-ID': this.organizationId!,
      'User-ID': this.userId!
    }
  }

  private async loadFeatureFlags() {
    try {
      if (!this.accessToken) return
      const response = await fetch(`${this.baseUrl}/features`, {
        headers: this.getHeaders()
      })
      const features = await response.json()
      this.features = new Set(features)
    } catch {
      this.features = new Set()
    } finally {
      this.loadingFeatures = undefined
    }
  }

  private async refreshFeatureFlags() {
    if (!this.loadingFeatures) this.loadingFeatures = this.loadFeatureFlags()
    return this.loadingFeatures
  }

  async hasFeatureFlag(name: string): Promise<boolean> {
    if (!this.accessToken) return false
    if (!this.features) await this.refreshFeatureFlags()
    if (this.features) return this.features.has(name)
    return false
  }

  track() {}
  clear() {
    this.userId = undefined
    this.locationId = undefined
    this.organizationId = undefined
    this.accessToken = undefined
    this.features = undefined
  }
  getRawTracker() {}
}
